import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

export const NotificationsDisclaimer: React.FC = () => {
  return (
    <S.Container>
      <Typography variant="content3" customClassName='text'>
        Por WhatsApp, você recebe 3 lembretes: um com <strong>24 horas</strong> de antecedência, outro com <strong>2 horas</strong> e também <strong>3 minutos antes</strong> da consulta começar.
      </Typography>
      <Typography variant="content3" customClassName='text'>
        Por SMS e e-mail, você recebe 2 lembretes: um com <strong>24 horas</strong> de antecedência e outro com <strong>2 horas</strong>.
      </Typography>
    </S.Container>
  )
}